import { CANCELLATION_DATE_ERRORS } from '@acorn-portal/shared/src/utils/constants/ErrorMessages';
import { isStaleDate } from '@acorn-portal/shared/src/utils/validation/helpers/is-stale-date';
import * as Yup from 'yup';

const errors = CANCELLATION_DATE_ERRORS;

const cancellationDateSchema = Yup.object().shape({
	cancellationDateDescription: Yup.string().required(errors.cancellationDateDescriptionRequired),
	cancellationDate: Yup.string().when('cancellationDateDescription', {
		is: 'LATER',
		then: () => Yup.string().required(errors.cancellationDateRequired),
	}),
	cancellationTime: Yup.object().when('cancellationDateDescription', {
		is: 'LATER',
		then: () =>
			Yup.object({
				hours: Yup.string(),
				minutes: Yup.string(),
			})
				.test('time-complete', errors.cancellationTimeRequired, (value) => !!value?.hours && !!value?.minutes)
				.test('date-not-in-past', errors.cancellationDateNotInPast, (value, context) => {
					const date = context.parent.cancellationDate ?? '';
					const hours = value?.hours ?? '';
					const minutes = value?.minutes ?? '';
					return !isStaleDate(date, hours, minutes);
				}),
		otherwise: () => Yup.object().notRequired(),
	}),
});

export default cancellationDateSchema;
